import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';

export default function Loader({determinate = false, value=0}) {
  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress style={{ color: 'rgb(255,255,255)' }} size={100} determinate={determinate} value={value} />
    </div>
  )
}
